var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('old-tooltip',{staticClass:"notification-saving",attrs:{"label":"We're saving the changes to your notification"}},[_c('spinner',{attrs:{"size":16}}),_c('span',{staticClass:"notification-saving__message"},[_vm._v("Saving…")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }